// extracted by mini-css-extract-plugin
module.exports = {"placeholderAd":"awareness-ad_placeholderAd__l0ClL","buzzfeed_news":"awareness-ad_buzzfeed_news__PTiNm"};